<template>
    <span class="time_selector">
        <select
            :name="hourName"
            v-model="hourValue"
        >
            <option
                v-for="option in hourOptions"
                :key="option"
                :value="option"
            >
                {{ option }}
            </option>
        </select>
        <span>:</span>
        <select
            :name="minuteName"
            v-model="minuteValue"
        >
            <option
                v-for="option in minuteOptions"
                :key="option"
                :value="option"
            >
                {{ option }}
            </option>
        </select>
    </span>
</template>

<script>
export default {
  name: 'app-time-select',
  props: {
        name: {
            type: String,
            default: ''
        },
        error: {
            type: Boolean,
            default: false
        },
        hourName: {
            type: String,
            default: ''
        },
        minuteName: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            hourValue: this.getHourValue(),
            minuteValue: this.getMinuteValue(),
            hourOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
            minuteOptions: ['00', '15', '30', '45']
        }
    },
    methods: {
        getHourValue() {
            if (this.value !== null) {
                return this.value.split(':')[0]
            } else {
                return '00'
            }
        },
        getMinuteValue() {
            if (this.value !== null) {
                return this.value.split(':')[1]
            }
            return '00'
        }
    },
    watch: {
        value() {
            this.hourValue = this.getHourValue()
            this.minuteValue = this.getMinuteValue()
        }
    }
}
</script>
